import { useEffect } from "react";
import SessionStorage from "../../../utils/SessionStorage";
import { isIOS } from "../../../utils/cob-utils";
import { DiagnosticCollectorProps } from "../CollectionTool/useDiagnosticCollection";

// Introduced originally in ApplicationCTA
// Moved to DiagnosticInformationCollector to separate concerns
// For more information, see: https://creditonebank.atlassian.net/browse/DPM-6751
const useSkipPADiagnosticCollection = (props: DiagnosticCollectorProps): void => {
    const handleStorageChange = (event: StorageEvent): void => {
        console[props.loggingLevel]({
            StorageEvent: event.key,
            OldValue: event.oldValue,
            NewValue: event.newValue,
        });
    };
    
    useEffect(() => {
        if (props.loggingLevel === 'disabled') {
            return () => {};
        }

        const skipPa = SessionStorage.tryGet<boolean>('skipPa', false);
        if (skipPa && isIOS()) {
            window.addEventListener('storage', handleStorageChange);
        }
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
}

export default useSkipPADiagnosticCollection;